import { useCallback, useEffect, useState } from "react";
import { api } from "@/api";

export const MODULES_CHANGED = "pag:modules-changed";
export const notifyModulesChanged = () => window.dispatchEvent(new Event(MODULES_CHANGED));

/** Modules « sur mesure » (Atelier IA) actifs pour l'utilisateur connecté — alimente les menus gérant / salarié. */
export function useActiveModules(enabled = true) {
  const [mods, setMods] = useState([]);
  const load = useCallback(() => { if (!enabled) return; api.get("/mod/active").then((r) => setMods(r.data.modules || [])).catch(() => setMods([])); }, [enabled]);
  useEffect(() => { load(); window.addEventListener(MODULES_CHANGED, load); return () => window.removeEventListener(MODULES_CHANGED, load); }, [load]);
  return mods;
}
